import { Typography } from "@mui/joy";

export default function Copyright() {
  return (
    <Typography level="body-xs" textAlign="center">
      © {new Date().getFullYear()} Christina.app
    </Typography>
  );
}
